//App
import { StateProps, StateContextData } from "../../../../types/state";
import { StatesContext } from "../StatesContainer";

import useForm from "../../../hooks/useForm";

const useStatehook = (props: StateProps) => {
  return useForm<StateContextData, StateProps>(StatesContext, props);
};

export default useStatehook;
